let config =  {
    BACKEND_ENDPOINT: process.env.REACT_APP_BACKEND_ENDPOINT,
    ITSM_URL: process.env.REACT_APP_ITSM_URL
};

export default config;
